"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDialog = exports.CustomDialogHeaderType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const dialog_1 = require("primereact/dialog");
const button_1 = require("primereact/button");
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var CustomDialogHeaderType;
(function (CustomDialogHeaderType) {
    CustomDialogHeaderType[CustomDialogHeaderType["Default"] = 1] = "Default";
    CustomDialogHeaderType[CustomDialogHeaderType["Create"] = 2] = "Create";
    CustomDialogHeaderType[CustomDialogHeaderType["Update"] = 3] = "Update";
    CustomDialogHeaderType[CustomDialogHeaderType["Add"] = 4] = "Add";
    CustomDialogHeaderType[CustomDialogHeaderType["Remove"] = 5] = "Remove";
    CustomDialogHeaderType[CustomDialogHeaderType["Select"] = 6] = "Select";
    CustomDialogHeaderType[CustomDialogHeaderType["Import"] = 7] = "Import";
    CustomDialogHeaderType[CustomDialogHeaderType["Export"] = 8] = "Export";
})(CustomDialogHeaderType = exports.CustomDialogHeaderType || (exports.CustomDialogHeaderType = {}));
const CustomDialog = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common']);
    const dialogFooter = typeof props.showFooter === 'boolean' && !props.showFooter
        ? null
        : ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [props.customButtons && props.customButtonsBefore && props.customButtons, props.onClick &&
                    (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ type: 'button', onClick: props.onClick, label: t(props.submitText ? props.submitText : 'ok'), icon: "pi pi-check", className: "p-button-text", disabled: props.isLoading === true }, { children: props.isLoading && (0, jsx_runtime_1.jsx)("span", { className: "pi pi-spin pi-spinner ml-2" }) })), props.formName && props.hideSave !== true &&
                    (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({ type: "submit", form: props.formName, label: t(props.submitText ? props.submitText : 'save'), icon: "pi pi-check", className: "p-button-text", disabled: typeof props.submitButtonDisabled === 'boolean' ? props.submitButtonDisabled : props.isLoading === true }, { children: props.isLoading && (0, jsx_runtime_1.jsx)("span", { className: "pi pi-spin pi-spinner ml-2" }) })) }), props.onClickWithClose && (0, jsx_runtime_1.jsx)(button_1.Button, { type: "submit", form: props.formName, label: t('saveAndClose'), icon: "pi pi-check", className: "p-button-text", disabled: typeof props.submitButtonDisabled === 'boolean' ? props.submitButtonDisabled : false, onClick: props.onClickWithClose }), props.customButtons && !props.customButtonsBefore && props.customButtons] }));
    const getHeader = () => {
        let result = undefined;
        let left = (0, jsx_runtime_1.jsx)("div", {});
        let right = (0, jsx_runtime_1.jsx)("div", {});
        switch (props.headerType) {
            case CustomDialogHeaderType.Create:
                // @ts-ignore
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faPlus }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Update:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faPen }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Add:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faPlus }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Remove:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faMinus }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Select:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faHandPointer }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Import:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faFileImport }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Export:
                left = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "sidebar-icon", icon: free_solid_svg_icons_1.faFileExport }), " ", props.header] });
                break;
            case CustomDialogHeaderType.Default:
                left = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.header });
                break;
            default:
                left = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.header });
                break;
        }
        if (props.buttonsInHeader) {
            right = dialogFooter;
        }
        if (props.doubleHeader) {
            // @ts-ignore
            result = (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'grid grid-nogutter' }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col m-auto' }, { children: left })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col-auto m-auto' }, { children: right }))] }));
        }
        else {
            // @ts-ignore
            result = left;
        }
        return result;
    };
    const getCustomIcons = () => {
        if (props.customIcons)
            return props.customIcons;
        else
            return null;
    };
    return ((0, jsx_runtime_1.jsx)(dialog_1.Dialog, Object.assign({ modal: true, onHide: () => props.onCancel(), visible: props.visible, header: getHeader(), maximizable: true, icons: getCustomIcons(), maximized: props.maximized ? props.maximized : false, footer: props.buttonsInHeader ? undefined : dialogFooter, className: props.className, style: props.style, contentClassName: props.contentClassName }, { children: props.children })));
};
exports.CustomDialog = CustomDialog;
